module.exports = __webpack_public_path__ + "static/media/Web_footer.03ae1888.svg";